import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Message,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Table,
} from 'semantic-ui-react';
import { parseISO } from 'date-fns';
import { isEmpty } from 'lodash';
import { formatLocalDateTime } from 'utils/dateTimeUtils';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import DefaultPagination from 'components/DefaultPagination';

function LogModal({
  title,
  shown,
  data,
  paging,
  isLoading,
  errors,
  onPageChange,
  onClose,
}) {
  return (
    <Modal open={shown} onClose={onClose} size="large">
      <ModalHeader>{title}</ModalHeader>
      <ModalContent scrolling>
        <Message negative hidden={isEmpty(errors)}>
          <Message.Header>Error</Message.Header>
          <ul>
            {errors.map(e => (
              <li key={e}>{e}</li>
            ))}
          </ul>
        </Message>
        <Table celled selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Time</Table.HeaderCell>
              <Table.HeaderCell>Logs</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {isLoading ? (
              <Table.Row>
                <Table.Cell colSpan={2}>
                  <LoadingSpinner />
                </Table.Cell>
              </Table.Row>
            ) : (
              data.map(log => (
                <Table.Row key={log.id}>
                  <Table.Cell>
                    {formatLocalDateTime(parseISO(log.time))}
                  </Table.Cell>
                  <Table.Cell>{log.log}</Table.Cell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
        {!isLoading && (
          <DefaultPagination
            totalCount={paging.total}
            activePage={paging.page}
            pageSize={paging.size}
            onPageChangeV2={onPageChange}
          />
        )}
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose}>Close</Button>
      </ModalActions>
    </Modal>
  );
}

LogModal.propTypes = {
  title: PropTypes.string.isRequired,
  shown: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: PropTypes.shape({
    page: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LogModal;
